// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("../../node_modules/regenerator-runtime/runtime.js");
var __webpack_exports__ = __webpack_require__("./src/frontend/entry_VibescoutFrontendSpecial.tsx");
